import * as Survey from 'survey-core';
import 'survey-js-ui'; // librairie pour interface javascript "vanilla"
import "survey-core/survey.i18n"; //pour pouvoir utiliser la locale fr
import "survey-core/survey-core.min.css";
import './custom_style.css'; // css custom

// Get the survey-core version
console.log("Version de survey-core chargée :", Survey.Version);

import surveyJson from './surveyModel.json'; // modèle du sondage
import themeJson from './survey_theme.json'; // thème du sondage

const apiConjointUrl = import.meta.env["VITE_API_SONDAGE"] + '/sondage';
if (import.meta.env.MODE !== 'production') {
    console.log("URL API Conjointe utilisée:", apiConjointUrl);
}
const surveyJsonStr = JSON.stringify(surveyJson).replace(/conjoint_api_url/g, apiConjointUrl);
const surveyJsonPatched = JSON.parse(surveyJsonStr);

console.log(">> startPage?", surveyJsonPatched.firstPageIsStartPage);

const survey = new Survey.Model(surveyJsonPatched);
survey.locale = 'fr';

// Ajouter pour que la config du conjoint soit enregistrée même si la question est invisible
survey.clearInvisibleValues = "none";

// Charger les duels depuis l'API et les injecter dans la question invisible
fetch(apiConjointUrl)
  .then(res => res.json())
  .then(data => {
    survey.setValue("conjoint_config", JSON.stringify(data));

    // Injecter les bons choix dans chaque question
    for (const duel of data.duels) {
      const q = survey.getQuestionByName(duel.qid);
      if (q) {
        if (!q.choices) q.choices = []; // Assure que la propriété existe
        q.choices = duel.items;
      }
    }
    console.log("Duel data loaded successfully:", data);
  })
  .catch(err => {
    console.error("Erreur lors du chargement des duels", err);
  });

survey.applyTheme(themeJson);


const SCROLL_DELAY_MS = 50; // délai de 100 ms
survey.onAfterRenderPage.add(function () {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, SCROLL_DELAY_MS); // petit délai (50 à 100 ms)
  });
  

  document.addEventListener("DOMContentLoaded", async function () {
    try {
      await waitForSurveyData(); // 👈 On attend l’injection des duels
      const container = document.getElementById("surveyContainer");
      survey.render(container);
      survey.onComplete.add(saveResults);
    } catch (err) {
      console.error("Erreur pendant l'initialisation du sondage :", err);
    }
  });
  
function waitForSurveyData() {
    return fetch(apiConjointUrl)
      .then(res => res.json())
      .then(data => {
        survey.setValue("conjoint_config", JSON.stringify(data));
        for (const duel of data.duels) {
          const q = survey.getQuestionByName(duel.qid);
          if (q) q.choices = duel.items;
        }
        console.log("✅ Données duels chargées.");
      });
  }
  

function saveResults(sender) {
    
    const results = JSON.stringify(sender.data);
    saveSurveyResults(sender.data);
}

function saveSurveyResults(json) {
    const url = import.meta.env["VITE_API_SONDAGE"] + '/sondage';
    let attempts = 0;
    const maxAttempts = 5;

    function sendRequest() {
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            },
            body: JSON.stringify(json)
        })
            .then(response => {
                if (response.ok) {
                    console.log('Sondage envoyé');
                } else {
                    throw new Error('Erreur lors de l\'envoi du sondage');
                }
            })
            .catch(error => {
                if (attempts < maxAttempts) {
                    attempts++;
                    console.error(`Tentative ${attempts} échouée, réessayer...`);
                    setTimeout(sendRequest, 1000);
                } else {
                    console.error('Une erreur s\'est produite lors de l\'envoi du sondage:', error);
                }
            });
    }

    sendRequest();
}
